<template>
  <v-container fluid fill-height>
    <v-toolbar>
      <v-select
        class="mt-5"
        @change="changeSubject"
        v-model="selectedSubject"
        :items="subjects"
        :rules="[v => v !== '' || 'Please choose a subject']"
        label="Subject"
        required
      ></v-select>
      <v-spacer></v-spacer>
      <v-select
        class="mt-5"
        @change="changeGrade"
        v-model="selectedGrade"
        :items="grades"
        item-text="name"
        :rules="[v => v !== '' || 'Grade is required']"
        label="Grade"
        required
      ></v-select>
      <v-spacer></v-spacer>
      <v-select class="mt-5" v-model="selectedDomain" :items="domains" label="Domain" clearable></v-select>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-switch class="mt-5" v-model="linkmode" v-on="on"></v-switch>
        </template>
        Link Mode {{linkmode ? 'On':'Off'}}
      </v-tooltip>
    </v-toolbar>
    <v-row style="height: 100%">
      <v-col cols="12" md="4" lg="3">
        <v-card>
          <v-list style="height: 500px; overflow-y: auto">
            <v-subheader>{{this.selectedDomain}}</v-subheader>
            <v-list-item-group>
            <v-list-item @click="clickNodeName(item.name)" v-for="item in nodes" :key="item.id">
              <v-list-item-title>{{item.name}}</v-list-item-title>
              <v-list-item-action>
                <v-tooltip top max-width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :title="item.name" icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{item.description}}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <v-dialog v-model="dialog">
          <v-card v-if="selectedNode">
            <v-toolbar>
              <v-btn @click="deleteNode" class="ma-2" text icon color="red lighten-2">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-title>
              <h3>Selected Standard</h3>
              {{selectedNode.category}} {{selectedNode.name}}
            </v-card-title>
            <v-card-text>
              <p>{{selectedNode.subCategory}}</p>

              <p>{{selectedNode.description}}</p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12" md="8" lg="9">
        <v-snackbar v-if="hoverNode" :value="true">
      <h4>{{hoverNode.subCategory}}</h4>
      {{hoverNode.description}}
    </v-snackbar>
        <d3-network

          @hook:mounted="networkLoaded"
          v-if="dataReady"
          @node-dblclick="nodeDblClick"
          @node-click="nodeClick"
          @link-click="linkClick"
          id="graph"
          ref="net"
          :net-nodes="nodes"
          :net-links="links"
          :options="options"
          :link-cb="lcb"
        />
      </v-col>
    </v-row>
    <v-btn bottom color="blue" dark fab fixed right @click="dialog = true">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog">
      <new-standard
        v-if="standard"
        :grades="grades"
        :subjects="subjects"
        :standard="standard"
        :key="standard.id"
        @close-dialog="dialog = false"
        @saved="addNewNode"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import D3Network from "vue-d3-network";
import Standards from "@/components/standards/";
import * as utils from "./utils.js";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      linkmode: false,
      dataReady: false,
      nodes: null,
      links: [],
      allLinks: [],
      standards: [],
      standard: null,
      nodeSize: 20,
      nodeHoverActivator: "",
      hoverNode: null,
      canvas: false,
      selectedNode: null,
      selectedLink: null,
      selectedGrade: 1,
      selectedSubject: "math",
      selectedDomain: null,
      domains: [],
      clusters: []
    };
  },
  computed: {
    ...mapGetters(["isAppLoading", "grades", "subjects"]),
    options() {
      return {
        force: 1000,
        nodeSize: this.nodeSize,
        nodeLabels: true,
        linkLabels: true,
        canvas: this.canvas,
        linkWidth: 2
      };
    }
  },
  watch: {
    selectedDomain(domain) {
      //when selected domain channges
      if (domain) {
        console.log(`new selected domain: ${domain}`);
        const filteredStandards = this.standards.filter(
          s => s.categoryName == domain
        );
        this.initNodes(filteredStandards, this.allLinks);
      } else {
        console.log("all domains");
        this.initNodes(this.standards, this.allLinks);
      }
    }
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage"]),
    lcb(link) {
      return link;
    },
    mouseOverCanvas(event) {
      console.log(event.target);
    },
    nodeDblClick() {
      this.linkmode = !this.linkmode;
    },
    nodeClick(evt, node) {
      //Skip any action if not link mode
      if (!this.linkmode) {
        return;
      }

      //In link mode, toggle link between selected and the clicked
      if (this.linkmode) {
        //Set selected mode if none was selected and return
        if (this.selectedNode == null) {
          node._color = "green";
          this.selectedNode = node;
          this.$set(this.nodes, node.index, this.selectedNode);

          return;
        }

        //find if existing link exist
        let existLinkIndex = this.links.findIndex(
          l =>
            (l.sid === this.selectedNode.id && l.tid === node.id) ||
            (l.tid === this.selectedNode.id && l.sid === node.id)
        );
        if (existLinkIndex > -1) {
          this.links.splice(existLinkIndex, 1);
          this.disconnectLinks(this.selectedNode.id, node.id);
        } else {
          //Set a link between the selected node and this
          let newlink = {
            sid: this.selectedNode.id,
            tid: node.id,
            _color: "red"
          };
          this.links.push(newlink);
          this.connectLinks(newlink.sid, newlink.tid);
        }

        //clear selected now once action is complete
        this.selectedNode._color = "black";
        this.$set(this.nodes, this.selectedNode.index, this.selectedNode);
        this.selectedNode = null;
      }
    },
    linkClick(evt, link) {
      this.selectedLink = link;
    },
    async connectLinks(srcId, dstId) {
      return await this.$axios
        .post(`ccStandard/connect?id1=${srcId}&id2=${dstId}`)
        .catch(resp => (this.error = resp));
    },
    async disconnectLinks(srcId, dstId) {
      return await this.$axios
        .post(`ccStandard/disconnect?id1=${srcId}&id2=${dstId}`)
        .catch(resp => (this.error = resp));
    },
    parseDomains(standards) {
      //parse unit categories from retrieved standards
      const categories = [...new Set(standards.map(s => s.categoryName))];

      return categories;
    },
    initNodes(standards, links) {
      this.nodes = standards.map(s => {
        return {
          id: s.id,
          name: s.standardCode,
          category: s.categoryName,
          subCategory: s.subCategory,
          description: s.standardDescription
        };
      });

      this.links = links
        .filter(link => {
          //filter out links not exist in nodes
          if (
            this.nodes.some(n => n.id === link.id_begin) &&
            this.nodes.some(n => n.id === link.id_end)
          ) {
            return true;
          } else {
            return false;
          }
        })
        .map(link => {
          return { sid: link.id_begin, tid: link.id_end, _color: "red" };
        });
    },
    loadData() {
      this.$axios
        .get("ccStandard/queryAll", {
          params: {
            grade: this.selectedGrade,
            subject: this.selectedSubject,
            includeLinks: true,
            size: 100
          }
        })
        .then(result => {
          this.standards = result.data.standards;
          this.allLinks = result.data.links;
          this.domains = this.parseDomains(this.standards);

          this.initNodes(this.standards, this.allLinks);

          this.dataReady = true;
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
    networkLoaded() {
      const network = this.$refs.net.$el;
      const circles = network.querySelectorAll("circle");
      for (let i = 0; i < circles.length; i++) {
        const circle = circles[i];
        circle.addEventListener("mouseenter", this.mouseEnterNode);
        circle.addEventListener("mouseleave", this.mouseLeaveNode);
      }
    },
    mouseEnterNode(e) {
      const circle = e.target;
      // console.log('mouse enter'+e)
      if (circle.style.fill != "green") {
        circle.style.fill = "red";
        circle.setAttribute("r", 12);
      }
      //set hoverNode
      const title = circle.getAttribute("title");
      this.hoverNode = this.nodes.find(n => n.name == title);
    },
    mouseLeaveNode(e) {
      // console.log('mouse leave'+e)
      if (e.target.style.fill == "red") {
        e.target.style.fill = "black";
        e.target.setAttribute("r", 10);
      }
      //clear hoverNode
      this.hoverNode = null;
    },
    clickNodeName(nodeName){
      this.standard = this.standards.find( s => s.standardCode == nodeName);
      
      this.dialog = true;
    },
    changeGrade() {
      this.loadData();
    },
    changeSubject() {
      this.loadData();
    },
    addNewNode(savedNode) {
      this.nodes.push(savedNode);
      this.dialog = false;
    },
    deleteNode() {
      this.$axios
        .delete(`ccStandard/${this.selectedNode.id}`)
        .then(response => {
          console.log(response.data);
          this.removeNode(this.selectedNode.id);
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    },
    removeNode(nodeId) {
      utils.removeNode(nodeId, this.nodes, nodes => {
        if (nodes) {
          this.links = this.rebuildLinks(nodes);
          this.selectedNode = null;
          //this.nodes = utils.rebuildNodes(this.links, nodes)
        }
      });
    },
    rebuildLinks(nodes) {
      if (!nodes) nodes = this.nodes;
      let links = utils.rebuildLinks(nodes, this.links);

      return links.newLinks;
    }
  },
  mounted() {
    this.loadData();
  },
  components: {
    D3Network,
    ...Standards
  }
};
</script>

<style>
.net {
  height: 100%;
}
</style>